import React from 'react'
import styled, { RuleSet } from 'styled-components'

interface InputElementProps {
  type?: 'default' | 'input'
  label: React.ReactNode
  isValid?: boolean
  disabled?: boolean
  children: React.ReactNode
  $inputStyle?: RuleSet<object>
  onClick?: () => void
}

const InputElement = ({
  type = 'default',
  label,
  isValid = true,
  disabled = false,
  $inputStyle,
  children,
  onClick,
}: InputElementProps) => {
  return (
    <S.InputElementContainer $disabled={disabled}>
      <S.label $isValid={isValid}>{label}</S.label>
      <div onClick={onClick ?? undefined}>
        {type === 'default' ? (
          <>{children}</>
        ) : (
          <S.InputContainer $style={$inputStyle}>{children}</S.InputContainer>
        )}
      </div>
    </S.InputElementContainer>
  )
}

export default InputElement

const S = {
  InputElementContainer: styled.div<{ $isValid?: boolean; $disabled?: boolean }>`
    opacity: ${({ $disabled }) => ($disabled ? 0.3 : 1)};
    pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
  `,
  label: styled.div<{ $isValid?: boolean }>`
    margin-bottom: 8px;
    color: ${({ $isValid }) => ($isValid === false ? '#ff0000' : '#717580')};
    font-size: 14px;
    line-height: 18px;
    & * {
      color: inherit;
    }
    strong {
      font-weight: 700;
    }
  `,
  InputContainer: styled.div<{ $style?: RuleSet<object> }>`
    position: relative;
    display: flex;
    align-items: center;
    padding: 0 16px;
    height: 50px;
    border-radius: 12px;
    border: 1px solid #ccd0d8;
    word-break: keep-all;
    font-size: 18px;
    font-weight: 800;
    line-height: 24px;

    & input {
      width: 70%;
      height: 100%;
      font-size: inherit;
      font-weight: inherit;
      color: #25282e;

      &::placeholder {
        color: #ccd0d8;
      }
    }

    ${(props) => props.$style};
  `,
}
